// Support.js
import { Outlet, useLocation, Navigate } from "react-router-dom";
import "./Support.css";

// MUI Icons
import TicketIcon from "@mui/icons-material/ConfirmationNumber";
import ChatIcon from "@mui/icons-material/Chat";
import GavelIcon from "@mui/icons-material/Gavel";
import WarningIcon from "@mui/icons-material/Warning";

const Support = () => {
  const location = useLocation();
  const path = location.pathname.split("/").pop();

  const tabs = [
    { key: "tickets", label: "Tickets", icon: <TicketIcon /> },
    { key: "chats", label: "Live Chat", icon: <ChatIcon /> },
    { key: "disputes", label: "Disputes", icon: <GavelIcon /> },
    { key: "safety", label: "Safety Incidents", icon: <WarningIcon /> },
  ];

  const getTitle = () => {
    const found = tabs.find((t) => t.key === path);
    return found ? found.label : "Support";
  };

  return (
    <div className="support-container">
      <div className="data_head">
        <h1 className="data_heading">{getTitle()}</h1>
      </div>

      <div className="support-content">
        <Outlet />
      </div>
    </div>
  );
};

export default Support;
